import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';

function invalidateProvision(qc, provisionId) {
  qc.invalidateQueries({ queryKey: ['forecasts', 'tree'] });
  qc.invalidateQueries({ queryKey: ['cash-flow'] });
  if (provisionId) {
    qc.invalidateQueries({ queryKey: ['provisions', provisionId, 'state'] });
    qc.invalidateQueries({ queryKey: ['provisions', provisionId, 'movements'] });
  }
}

/**
 * Enregistre un mouvement sur une provision.
 * Payload : { id, kind, amount_cents, effective_date, counterpart_id?, notes? }
 */
export function useRecordProvisionMovement() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) =>
      api.post(`/provisions/${id}/movements`, body),
    onSuccess: (_data, { id }) => invalidateProvision(qc, id),
  });
}

/**
 * Clôture une provision.
 * Payload : { id }
 */
export function useCloseProvision() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id }) => api.post(`/provisions/${id}/close`),
    onSuccess: (_data, { id }) => invalidateProvision(qc, id),
  });
}

/**
 * Récupère les mouvements d'une provision (query, pas mutation).
 * Utilisé par ProvisionDetailDrawer pour l'historique.
 */
import { useQuery } from '@tanstack/react-query';

export function useProvisionMovements(provisionId, { limit = 10, offset = 0 } = {}) {
  return useQuery({
    queryKey: ['provisions', provisionId, 'movements', { limit, offset }],
    queryFn: () =>
      api.get(`/provisions/${provisionId}/movements?limit=${limit}&offset=${offset}`),
    staleTime: 30_000,
    enabled: Boolean(provisionId),
  });
}
